import * as actionType from './actionType';

const reducerMap = {
    /*获取任务列表*/
    [actionType.getTaskListRequest]: (state, payload) => {
        return Object.assign({}, state, {
            
        });
    },
    [actionType.getTaskListSuccess]: (state, payload) => {
        return Object.assign({}, state, {
            taskList: payload.data.list,
            total:payload.data.total,
        });
    },
    [actionType.getTaskListFailure]: (state, payload) => {
        return Object.assign({}, state, {
            
        });
    },

    /*获取打标签列表*/
    [actionType.getSelectListRequest]: (state, payload) => {
        return Object.assign({}, state, {

        });
    },
    [actionType.getSelectListSuccess]: (state, payload) => {
        return Object.assign({}, state, {
            selectList: payload.data.list,
        });
    },
    [actionType.getSelectListFailure]: (state, payload) => {
        return Object.assign({}, state, {

        });
    },
    /*获取审核列表*/
    [actionType.getCheckListRequest]: (state, payload) => {
        return Object.assign({}, state, {

        });
    },
    [actionType.getCheckListSuccess]: (state, payload) => {
        return Object.assign({}, state, {
            checkList: payload.data.list,
        });
    },
    [actionType.getCheckListFailure]: (state, payload) => {
        return Object.assign({}, state, {

        });
    },

    /*获取类型列表*/
    [actionType.getFilterListRequest]: (state, payload) => {
        return Object.assign({}, state, {

        });
    },
    [actionType.getFilterListSuccess]: (state, payload) => {
        return Object.assign({}, state, {
            filterList: payload.data.node_knowledge_type,
        });
    },
    [actionType.getFilterListFailure]: (state, payload) => {
        return Object.assign({}, state, {

        });
    },
    [actionType.setStage]: (state, payload) => {
        return Object.assign({}, state, {
            stage:payload.data
        });
    },
}
export const INITIALIZE_STATE = {
    taskList: [],
    taskCount: 0,
    selectList:[],
    checkList:[],
    filterList:[],
    stage:'1',
}
export default (state = INITIALIZE_STATE, action = {}) => {
    const { type, payload } = action;
    const reducer = reducerMap[type];
    if (reducer) {
        return reducer(state, payload);
    } else {
        return state;
    }
};



// WEBPACK FOOTER //
// ./src/entry_app/question_manage/set_tag/reducer.js